class DoctorSearchController {
	$onInit() {
		this.selectedPlan = null;
		this.selectedAddress = null;
		this.selectedDoctor = null;
	}

	onSearchButtonClick() {
		this.onSearch({
			$event: {
				selectedPlan: this.selectedPlan,
				selectedAddress: this.selectedAddress,
				selectedDoctor: this.selectedDoctor
			}
		});
	}

	changeSelectedPlan({value}) {
		this.selectedPlan = value;
		this.onSearch({
			$event: {
				selectedPlan: this.selectedPlan,
				selectedAddress: this.selectedAddress,
				selectedDoctor: this.selectedDoctor
			}
		});
	}
	onSelectAddress({value}) {
		this.selectedAddress = value;
	}

	onSelectDoctorOrCondition({value}) {
		this.selectedDoctor = value;
	}
}

export default DoctorSearchController;



// WEBPACK FOOTER //
// ./~/@front10/healthcare-book/src/app/components/doctor-search/doctor-search.controller.js